export default __webpack_public_path__ + "static/track_time_using_powerup_v3-64b64b46a9cc46fa45705cd983cf7368.gif";